var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "custom-form" },
    _vm._l(_vm.fields, function(f, index) {
      return _c(
        "div",
        { key: index, staticClass: "field-item-wrap" },
        [
          _c(f.type, {
            ref: "field_" + index,
            refInFor: true,
            tag: "component",
            attrs: { field: f },
            on: {
              "update:field": function($event) {
                f = $event
              }
            }
          })
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-86a82cb2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-86a82cb2","hasScoped":true,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/compEditForm/customForm.vue
// module id = 1230
// module chunks = 7